//current endpoint for cloud functions
let cloudFunctionUrl;
if (window.location.hostname.indexOf('localhost') > -1) {
    cloudFunctionUrl = 'http://localhost:5001/digital-pool/us-central1/';
} else {
    cloudFunctionUrl = 'https://us-central1-digital-pool.cloudfunctions.net/';
}

export default cloudFunctionUrl;
